// extracted by mini-css-extract-plugin
export default {"goBack":"frenet_goBack__kTOi2","configItem":"frenet_configItem__imVwZ","configDimensions":"frenet_configDimensions__YEE5c"};